'use client'

import { useEffect, useState } from 'react'

import { useDisplayCart } from 'modules/cart'
import toast from 'shared/ui/utils/toast'

import { SaleOrder } from '../../../types'
import {
  getEditDataFromLocalStorage,
  getStartSaleOrderFromLocalStorage
} from '../utils'

export const useEditSaleOrderModal = () => {
  const [cancelEditOpen, setCancelEditOpen] = useState<boolean>(false)
  const [submitEditOpen, setSubmitEditOpen] = useState<boolean>(false)
  const [startOrder, setStartOrder] = useState<SaleOrder | null>(null)
  const [editStartModalOpen, setEditStartModalOpen] = useState<boolean>(false)
  const cart = useDisplayCart()

  useEffect(() => {
    if (!startOrder && cart) {
      setOrderDataFromLocalStorage()
    }
  }, [startOrder, cart])

  const setOrderDataFromLocalStorage = () => {
    setStartOrder(getStartSaleOrderFromLocalStorage())
  }

  const clearStates = () => {
    setStartOrder(null)
    setCancelEditOpen(false)
    setSubmitEditOpen(false)
    setEditStartModalOpen(false)
  }

  const handleCancelEditOrder = () => {
    setCancelEditOpen(true)
  }

  const handleCloseCancelEditModal = () => {
    setCancelEditOpen(false)
  }

  const handleSubmitEditOrder = () => {
    const {
      startCart,
      startOrder: startOrderStorage,
      startPaymentMethod
    } = getEditDataFromLocalStorage()

    if (!startCart || !startOrderStorage || !startPaymentMethod) {
      toast.error(
        'Nie pobrano danych wymaganych do edycji zamówiania. Anuluj edycję i spróbuj ponownie.'
      )

      return
    }
    setSubmitEditOpen(true)
  }

  const handleCloseSubmitEditModal = () => {
    setSubmitEditOpen(false)
  }

  const handleEditStartModalOpen = () => {
    if (cart?.editMode) {
      toast.error(
        'Jesteś w trakcie edycji zamówienia. Ukończ lub anuluj obecną edycję i spróbuj ponownie.'
      )

      return
    }
    setEditStartModalOpen(true)
  }
  const handleEditStartModalClose = () => {
    setEditStartModalOpen(false)
  }

  return {
    startOrder,
    cancelEditOpen,
    submitEditOpen,
    editStartModalOpen,
    handleCancelEditOrder,
    handleCloseCancelEditModal,
    handleSubmitEditOrder,
    handleCloseSubmitEditModal,
    handleEditStartModalClose,
    handleEditStartModalOpen,
    setOrderDataFromLocalStorage,
    clearStates
  }
}
